<a class="shortcut-menu__button" [href]="url()" target="_blank">
  <svg-icon src="assets/images/icons/documentation.svg"></svg-icon>
  <span>{{ "ShortcutMenu.ServiceDocumentation" | translate }}</span>
</a>
